"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessPermissionsSortToJSON = exports.GetBusinessPermissionsSortFromJSONTyped = exports.GetBusinessPermissionsSortFromJSON = exports.GetBusinessPermissionsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetBusinessPermissionsSort;
(function (GetBusinessPermissionsSort) {
    GetBusinessPermissionsSort["Email"] = "email";
})(GetBusinessPermissionsSort = exports.GetBusinessPermissionsSort || (exports.GetBusinessPermissionsSort = {}));
function GetBusinessPermissionsSortFromJSON(json) {
    return GetBusinessPermissionsSortFromJSONTyped(json, false);
}
exports.GetBusinessPermissionsSortFromJSON = GetBusinessPermissionsSortFromJSON;
function GetBusinessPermissionsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetBusinessPermissionsSortFromJSONTyped = GetBusinessPermissionsSortFromJSONTyped;
function GetBusinessPermissionsSortToJSON(value) {
    return value;
}
exports.GetBusinessPermissionsSortToJSON = GetBusinessPermissionsSortToJSON;
